import api from "@/lib/axiosConfig";

export type BoPreferenceItem = {
  logicalKey: string;
  config: unknown;
};

export type BoPreferencesListResponse = {
  instanceSlug: string;
  items: BoPreferenceItem[];
};

export async function fetchBoPreferences(): Promise<BoPreferencesListResponse> {
  const { data } = await api.get<BoPreferencesListResponse>(
    "back/api/user-config/bo",
  );
  return data;
}

export async function upsertBoPreference(
  logicalKey: string,
  config: unknown,
): Promise<void> {
  await api.put(
    `back/api/user-config/bo/${encodeURIComponent(logicalKey)}`,
    { config },
  );
}

export async function bulkUpsertBoPreferences(
  items: BoPreferenceItem[],
): Promise<void> {
  if (items.length === 0) return;
  await api.put("back/api/user-config/bo", { items });
}
